import {  CASH_PAYMENT_TRANSACTION_REQUEST, CASH_PAYMENT_TRANSACTION_REQUEST_FAILURE, GET_CASH_PAYMENT_TRANSACTIONS } from '../types';

const initialState = {
  cashPaymentTransactions: [],
  loading: false,
  error: null,
};

const cashPaymentTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CASH_PAYMENT_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_CASH_PAYMENT_TRANSACTIONS: {
      return {
        ...state,
        cashPaymentTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CASH_PAYMENT_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default cashPaymentTransactionReducer;